<template>
  <b-form-group
    label="Misyon Başlık"
    label-for="mission_title"
  >
    <validation-provider
      #default="{ errors }"
      name="Misyon Başlık"
      rules="required"
    >
      <b-form-input
        id="mission_title"
        v-model="itemData.mission_title"
        placeholder="Misyon Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'MissionTitle',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['about/dataItem']
    },
  },
}
</script>
